// extracted by mini-css-extract-plugin
export default {"skeletonCard":"insights-skeleton_skeletonCard__VdvtU","skeletonChartCard":"insights-skeleton_skeletonChartCard__3g2wR"};